import { ComponentType, useEffect } from "react";

export const withScrollRestoration = <T extends object>(Component: ComponentType<T>) => {
    const WrapperComponent = (props: T) => {
        useEffect(() => {
            setTimeout(() => window.scrollTo(0, 0), 0);
        }, []);

        return <Component {...props} />;
    };

    WrapperComponent.displayName = `withScrollRestoration(${Component.displayName || ''})`;

    return WrapperComponent;
};